import { ChangeDetectorRef, Directive, HostBinding, Input, OnInit } from '@angular/core';

// temp repeat until I can full untwist ui-components
@Directive({
  selector: '[ctAutomatedSelector]',
})
export class AutomatedSelectorDirective implements OnInit {
  private _automatedName: string;
  @Input()
  public ctAutomatedSelector;

  @Input()
  set automatedName(name: string) {
    this._automatedName = name;
    this.automatedDataName = this._automatedName;
    this.cd.markForCheck();
  }

  get automatedName(): string {
    return this._automatedName;
  }

  @HostBinding('attr.data-aid') public automatedTag;

  @HostBinding('attr.data-aid-name') public automatedDataName;

  constructor(private cd: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.automatedTag = this.ctAutomatedSelector;
    this.automatedDataName = this.automatedName;
  }
}
